'use strict';//Indicating browser should run only in java script mode
; (function () {
    angular.module('EMR.SelectColonoscopyProcedureModule', []);

    var selectColonoscopyProcedureModuleRoutes = [

        {
            "name": "SelectColonoscopyProcedurePopup",
            "url": "SelectColonoscopyProcedurePopup",
            "templateUrl": "AngularScripts/SelectColonoscopyProcedure/Htmls/SelectColonoscopyProcedurePopup.html",
            "RoutingNumber": 4644,
            files: [
                "AngularScripts/SelectColonoscopyProcedure/Services/SelectColonoscopyProcedureService.js",
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/SelectColonoscopyProcedure/Controllers/SelectColonoscopyProcedurePopupController.js",

            ]
        },
        
    ];

    angular.module('EMR.SelectColonoscopyProcedureModule')
    .constant("selectColonoscopyProcedureModuleRoutes", selectColonoscopyProcedureModuleRoutes)
    .config(["$stateProvider", "EmrRouteProvider", "selectColonoscopyProcedureModuleRoutes",
        function ($stateProvider, EmrRouteProvider, selectColonoscopyProcedureModuleRoutes) {
            EmrRouteProvider.registerStates(selectColonoscopyProcedureModuleRoutes, $stateProvider);
        }]);
})();
